import oracleApiUrl from './oracle-api-url.js';

/** Oracle backend proxy — normal production path for Oyster routes. */
export const oysterProxyBaseUrl = `${oracleApiUrl}/oyster`;

/**
 * Local Oyster used only when the proxy is unreachable (development fallback).
 * Override with REACT_APP_OYSTER_FALLBACK_URL if needed.
 */
export const oysterLocalFallbackUrl = (
    process.env.REACT_APP_OYSTER_FALLBACK_URL || 'http://localhost:3001'
).replace(/\/$/, '');

/** @deprecated Use oysterProxyBaseUrl — kept for existing imports. */
const oysterApiUrl = oysterProxyBaseUrl;

export default oysterApiUrl;
